import { useQuery } from '../../../hooks';

import * as aiToolkitService from '../service';
import { AIToolkitCacheKeys } from '../consts';

export const useMyGptJobs = () => {
  const getMyGptJobs = useQuery({
    queryFn: aiToolkitService.getMyGptJobs,
    queryKey: [AIToolkitCacheKeys.GetMyGptJobs],
  });

  return {
    getMyGptJobs,
  };
};
